import React from "react";
import * as Icon from "react-feather";
import { getClientQuestion } from "../clientQuestionTemplates";
import "../../../../afs-walkthrough.css";
import WComponent from "../../../../../../../common/WComponent";

function computeDefaultItemType(checkId) {
	// Auto-select item type based on check context
	let defaultItemType = "clarification";
	if (checkId) {
		let id = checkId.toUpperCase();
		// Documentation: checks that need schedules, agreements, certificates, statements
		let docChecks = ["CA_01", "CA_02", "CA_05", "INT_01", "INT_03", "DEBT_01", "DEBT_03", "RE_01", "SH_01", "TXN_INS_01", "TXN_RENT_01", "GIFI_01"];
		// Confirmation: checks that need a yes/no or a number from the client
		let confirmChecks = ["EQ_01", "EQ_03", "EQ_04", "TXN_LEG_01", "TXN_MEAL_01", "TXN_VEH_01", "TXN_WAGE_01", "TXN_CAP_01", "TAX_04", "GC_01", "ACC_01"];
		if (docChecks.includes(id)) defaultItemType = "documentation";
		else if (confirmChecks.includes(id)) defaultItemType = "confirmation";
	}
	return defaultItemType;
}

class AddRequestModal extends WComponent {
	state = {
		question: getClientQuestion(this.props.checkId, this.props.checkLabel, this.props.checkDetail),
		itemType: computeDefaultItemType(this.props.checkId),
		blocking: this.props.checkTier <= 2,
		adding: false,
		added: false,
	};

	handleAdd = async () => {
		let { checkId, checkDetail, onAdd } = this.props;
		let { question, itemType, blocking } = this.state;
		if (!question.trim()) return;
		this.update({ adding: true });
		if (onAdd) {
			await onAdd({
				question: question.trim(),
				context: checkDetail || null,
				sourceCheckId: checkId || null,
				itemType: itemType,
				blocking: blocking,
			});
		}
		this.update({ adding: false });
		this.update({ added: true });
	};

	render() {
	let { onClose } = this.props;
	let { question, itemType, blocking, adding, added } = this.state;
	let handleAdd = this.handleAdd;

	if (added) {
		return (
			<div className="afs-add-request">
				<div className="afs-add-request__confirmed">
					<Icon.CheckCircle size={16} color="#2e7d32" />
					<span>Added to client requests</span>
					<button className="afs-add-request__close" onClick={onClose}><Icon.X size={14} /></button>
				</div>
			</div>
		);
	}

	return (
		<div className="afs-add-request">
			<div className="afs-add-request__header">
				<span className="afs-add-request__title">Add to Client Requests</span>
				<button className="afs-add-request__close" onClick={onClose}><Icon.X size={14} /></button>
			</div>
			<div className="afs-add-request__form">
				<div className="afs-add-request__field">
					<label className="afs-add-request__label">Question for client</label>
					<textarea className="afs-add-request__textarea" rows={2} value={question} onChange={(e) => { this.update({ question: e.target.value }); }} />
				</div>
				<div className="afs-add-request__row">
					<div className="afs-add-request__type-group">
						{["clarification", "documentation", "confirmation"].map(function (t) {
							return (
								<button key={t} type="button" className={"afs-add-request__type-btn" + (itemType === t ? " afs-add-request__type-btn--active" : "")} onClick={() => { this.update({ itemType: t }); }}>
									{t.charAt(0).toUpperCase() + t.slice(1)}
								</button>
							);
						})}
					</div>
					<button type="button" className={"afs-add-request__blocking-btn" + (blocking ? " afs-add-request__blocking-btn--active" : "")} onClick={() => { this.update({ blocking: !blocking }); }}>
						Blocking
					</button>
				</div>
				<button className="afs-add-request__submit" disabled={!question.trim() || adding} onClick={handleAdd}>
					{adding ? "Adding..." : "Add to List"}
				</button>
			</div>
		</div>
	);
	}
}

export default AddRequestModal;
